import { render, staticRenderFns } from "./UploaderImage.vue?vue&type=template&id=3e74de1b"
import script from "./UploaderImage.vue?vue&type=script&lang=js"
export * from "./UploaderImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports